import {ControlMode} from '.'

// This mode is responsible for spinning the model if there is no
// user interaction, and not spinning the model when there is any
class AttractMode extends ControlMode {
  delay = 1.5 * 1000 // 1.5 seconds
  requested: number | null = null
  spinRate = 0.0

  onActivate() {
    this.requested = Date.now()
    this.spinRate = 0.01
  }

  tick() {
    if (!this.requested) {
      return
    }

    const elapsedTime = this.delay + this.requested
    if (elapsedTime >= Date.now()) {
      return
    }

    this.controls.orbitRight((this.controls.orbitIncrement / 2) * this.spinRate)
    if (this.spinRate < 1.0) {
      this.spinRate *= 1.03
    }
  }
}

export default AttractMode
